// The one card-image lightbox. Built lazily, appended to <body>, sits above every
// sheet and the mobile nav (z-index 12600 in site.css). Escape, Back, the X and a tap
// outside the image close it.

import { openSheet, closeSheet, isSheetOpen } from './sheet';

let box: HTMLElement | null = null;
let img: HTMLImageElement | null = null;

function ensure(): HTMLElement {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'doc-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Card image');
    box.hidden = true;
    box.innerHTML =
        '<button type="button" class="doc-lightbox__close" aria-label="Close">' +
        '<i class="fa-solid fa-xmark" aria-hidden="true"></i></button>' +
        '<img alt="" />';
    img = box.querySelector('img');
    document.body.appendChild(box);

    box.addEventListener('click', (e) => {
        const t = e.target as Element;
        if (img && (t === img || img.contains(t))) return;
        closeLightbox();
    });
    return box;
}

export function openLightbox(src: string, alt = ''): void {
    if (!src) return;
    const el = ensure();
    if (img) { img.src = src; img.alt = alt; }
    openSheet(el, { overlay: null, swipe: false, hideOnClose: true, history: true });
}

export function closeLightbox(): void {
    if (!box || !isSheetOpen(box)) return;
    closeSheet(box);
    setTimeout(() => { if (img && !isSheetOpen(box!)) img.removeAttribute('src'); }, 320);
}
